import { useSyncExternalStore } from 'react';

const query = '(prefers-reduced-motion: no-preference)';

const subscribe = (onChange: () => void) => {
  const mediaQueryList = window.matchMedia(query);
  mediaQueryList.addEventListener('change', onChange);
  return () => mediaQueryList.removeEventListener('change', onChange);
};

const getSnapshot = () => !window.matchMedia(query).matches;
const getServerSnapshot = () => true;

export default function usePrefersReducedMotion() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
